import type { ObjectAny } from '../../types/ObjectAny'

export interface queryStateCreatorMapType {
    from: string
    to: string
    defaultValue?: string
    test?: RegExp
    decorator?: (a: string) => any
}

export const queryStringMatcher = <T = ObjectAny>(searchParams: ObjectAny, config: queryStateCreatorMapType[]): T => {
    if (config.length === 0) {
        return {} as T
    }

    return config.reduce((c, element) => {
        const param = searchParams[element.from]

        if (!param) {
            return {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ...c,
                [element.to]: element.defaultValue ? element.defaultValue : undefined,
            }
        }

        if (element.test && typeof param === 'string' && !param.match(element.test)) {
            return {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ...c,
                [element.to]: element.defaultValue ? element.defaultValue : undefined,
            }
        }

        return {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...c,
            [element.to]: element.decorator ? element.decorator(param) : param,
        }
    }, {} as T)
}
